// Keep document names consistent across downloads and safe for local filesystems.
const cleanFilename = (value, limit) => {
  const text = String(value).replace(/[\\/:*?"<>|]/g, '_');
  let result = '', bytes = 0;
  for (const raw of text) {
    const char = raw.charCodeAt(0) < 32 ? '_' : raw;
    const point = char.codePointAt(0);
    const size = point <= 0x7f ? 1 : point <= 0x7ff ? 2 : point <= 0xffff ? 3 : 4;
    if (bytes + size > limit) break;
    result += char;
    bytes += size;
  }
  return result.replace(/^[ .]+|[ .]+$/g, '');
};

export const documentFilename = (kind, info, suffix = '') => {
  const order = info || {};
  const code = `${order.prefix || ''}${order.code || ''}` || order.id || '';
  const base = `${kind}-${order.bidder || ''}-${code}-${order.project || ''}`;
  return `${cleanFilename(base, 180)}${cleanFilename(suffix, 40)}.pdf`;
};
